import { NavLink } from 'react-router';
import {
  DollarSign,
  Server,
  Box,
  ArrowDownUp,
  LogOut,
  Rocket,
  Activity,
  Users,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/hooks/use-auth';

const navItems = [
  { to: '/costs', label: 'Cost Overview', icon: DollarSign },
  { to: '/ingestion', label: 'Ingestion', icon: ArrowDownUp },
  { to: '/api-metrics', label: 'API', icon: Activity },
  { to: '/user-activity', label: 'User Activity', icon: Users },
  { to: '/infrastructure', label: 'Infrastructure', icon: Server },
  { to: '/devboxes', label: 'Devboxes', icon: Box },
  { to: '/release', label: 'Release', icon: Rocket },
];

export function Sidebar() {
  const { state, signOut } = useAuth();
  return (
    <aside
      className="flex h-screen w-56 flex-col border-r"
      style={{ background: 'var(--sidebar-bg)', color: 'var(--sidebar-foreground)' }}
    >
      <div
        className="flex h-14 items-center px-4"
        style={{ borderBottom: '1px solid var(--sidebar-border)' }}
      >
        <span className="text-lg font-semibold">Overhead Ops</span>
      </div>
      <nav className="flex-1 space-y-1 p-2">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive ? 'bg-primary text-primary-foreground' : 'hover:bg-[var(--sidebar-accent)]'
              )
            }
            style={{ color: 'var(--sidebar-foreground)' }}
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="space-y-2 p-3" style={{ borderTop: '1px solid var(--sidebar-border)' }}>
        {state.status === 'signedIn' && (
          <p className="truncate px-1 text-xs opacity-70" title={state.email}>
            {state.email}
          </p>
        )}
        <button
          onClick={() => void signOut()}
          className="flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors hover:bg-[var(--sidebar-accent)]"
          style={{ color: 'var(--sidebar-foreground)' }}
        >
          <LogOut className="h-4 w-4" />
          Sign out
        </button>
      </div>
    </aside>
  );
}
